import { render, staticRenderFns } from "./Taggeable.vue?vue&type=template&id=96f607f0&"
import script from "./Taggeable.vue?vue&type=script&lang=js&"
export * from "./Taggeable.vue?vue&type=script&lang=js&"
import style0 from "./Taggeable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96f607f0')) {
      api.createRecord('96f607f0', component.options)
    } else {
      api.reload('96f607f0', component.options)
    }
    module.hot.accept("./Taggeable.vue?vue&type=template&id=96f607f0&", function () {
      api.rerender('96f607f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/billing/components/Taggeable.vue"
export default component.exports